module.exports = __webpack_public_path__ + "img/biaoti2.e23e69ce.png";